<template>
    <q-banner v-if="!consentChecked"
              class="bg-dark text-white slide-up-banner consent-banner"
              :class="{ 'visible': showBanner }">
        <div class="row items-start cookies-row">
            <div class="col-12 col-sm-8">
                We may use cookies and similar technologies to enhance site navigation, analyze site usage, and save your preferences.
                By accessing or using our sites and services, you agree to this collection and disclosure of your information as described further in our
                <router-link class="text-white" style="text-decoration: underline;" to="/privacy">Privacy Policy</router-link>.
            </div>
            <div class="col-12 col-sm-4 text-center consent-btns-container">
                <q-btn class="bg-dark text-white q-ma-xs consent-btn"
                       style="border: 1px solid currentColor;"
                       label="Essential Only"
                       @click="declineConsent" />
                <q-btn class="q-ma-xs consent-btn"
                       color="primary"
                       label="Allow All"
                       @click="acceptConsent" />
            </div>
        </div>
        <div class="row tou-row">
            <p style="margin: 0;"><router-link class="text-white" style="text-decoration: underline;" to="/terms">Terms of Use</router-link> Last Updated on: {{ termsLastUpdated }}</p>
        </div>
    </q-banner>
</template>
<script>
    import { TERMS_LAST_UPDATED } from '@/plugins/menuItems'
    import { format, parseISO } from 'date-fns'

    export default {
        name: 'consent-banner',
        data() {
            return {
                consentChecked: localStorage.getItem('ga_consent'),
                consentTimestamp: localStorage.getItem('ga_consent_timestamp'),
                showBanner: false,
                termsLastUpdated: format(parseISO(TERMS_LAST_UPDATED), 'MMMM d, yyyy'),
            };
        },
        mounted() {
            const now = Date.now();
            const oneYear = 365 * 24 * 60 * 60 * 1000;
            const sixMonths = 6 * 30 * 24 * 60 * 60 * 1000;

            // If consent was given less than 1 year ago add ga tag
            if (this.consentTimestamp !== null && this.consentChecked === 'true' && now - this.consentTimestamp < oneYear) {
                this.initGtag();
                return;
            }
            // If consent was declined less than 6 months ago do nothing
            if (this.consentTimestamp !== null && this.consentChecked === 'false' && now - this.consentTimestamp < sixMonths) {
                return;
            }

            // If no consent was given or refused or timestamp is expired or not set clear the consent and show the banner
            localStorage.removeItem('ga_consent');
            this.consentChecked = false;

            localStorage.removeItem('ga_consent_timestamp');
            this.consentTimestamp = null;

            setTimeout(() => {
                this.showBanner = true;
            }, 100);
        },
        methods: {
            acceptConsent() {
                localStorage.setItem('ga_consent', 'true');
                localStorage.setItem('ga_consent_timestamp', Date.now());
                this.consentChecked = true;
                this.initGtag();
            },
            declineConsent() {
                localStorage.setItem('ga_consent', 'false');
                localStorage.setItem('ga_consent_timestamp', Date.now());
                this.consentChecked = true;
            }
        }
    };
</script>
<style scoped>
    .consent-banner {
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 999;
    }

    .slide-up-banner {
        transform: translateY(100%);
        opacity: 0;
        transition: transform 1s ease, opacity 1s ease;
    }

        .slide-up-banner.visible {
            transform: translateY(0);
            opacity: 1;
        }

    .consent-btns-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: center;
        padding: 10px;
    }

    .consent-btn {
        flex: 1;
        min-width: 115px;
    }

    .cookies-row {
        max-width: 1200px;
        margin: 0 auto;
        padding: 10px;
    }

    .tou-row {
        max-width: 1200px;
        margin: 0px auto;
        padding: 0 10px;
        font-size: 0.65rem;
    }
</style>
